import { createContext } from 'react'
import { TFeatureFlagsMap } from './TFeatureFlagsMap'

export const FeatureFlagsContext = createContext<TFeatureFlagsMap>({})
